// this is an autogenerated file from App/Widget/data.graphql
import { gql } from 'Data/Api'

let query = gql`
query app__App_Widget{
  widget: leads_get_configuration {
    settings
    questions
  }
}

`
export default query
